import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Shorttripdestinationmorachi() {



    const cardData =
    {
        keyword: 'Short Trip Destinations Morachi Chincholi Pune',
        heading: 'Anand Krushi Paryatan Kendra: Short Trip Destinations Morachi Chincholi Pune',
        headingDescription: 'Looking to unwind with a quick getaway? Anand Krushi Paryatan Kendra is one of the most popular short trip destinations Morachi Chincholi Pune has to offer. Just 55 km from the city, this 40-acre agri-tourism retreat is ideal for families, school excursions, and corporate outings seeking a refreshing rural experience. The farm is packed with activities including bullock cart and tractor rides, horse riding, boating, swimming, and a lively rain dance area. Traditional village games, puppet shows, and magic shows provide cultural fun for all age groups.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Morachi Chincholi – The Peacock Village",
    "description": "A peaceful village just 55 km from Pune, famous for its free-roaming peacocks, lush farms, and serene countryside. Perfect for nature walks, photography, and relaxing day trips away from city life."
  },
  {
    "title": "Anand Krushi Paryatan Kendra",
    "description": "A top-rated agro-tourism spot in Morachi Chincholi offering tractor and bullock cart rides, organic farming experiences, splash pools, pottery making, rural games, and authentic Maharashtrian thali meals."
  },
  {
    "title": "Ranjangaon Mahaganpati Temple",
    "description": "One of the Ashtavinayak Ganpati temples located about 30 minutes from Morachi Chincholi. A spiritually uplifting destination with traditional architecture and a calm setting."
  },
  {
    "title": "Ghod River Backwaters",
    "description": "A hidden, scenic spot ideal for a riverside picnic or quiet time in nature. Located close to Morachi Chincholi, it’s great for birdwatching and peaceful family moments."
  },
  {
    "title": "Tulapur Historical Ghat",
    "description": "A place of Maratha history, located at the confluence of the Bhima and Indrayani rivers. Visit the memorial of Chhatrapati Sambhaji Maharaj and enjoy the riverside setting."
  },
  {
    "title": "Pabal Vigyan Ashram",
    "description": "An educational short trip option for students and curious minds. This rural innovation center near Morachi Chincholi showcases sustainable farming, solar tech, and simple rural engineering."
  },
  {
    "title": "Seasonal Hurda Party Experience",
    "description": "From November to February, enjoy a farm-based feast with roasted jowar (hurda), jaggery, chutney, folk music, and open-air vibes — a popular rural event near Morachi Chincholi."
  }
],




"services": [
  {
    "name": "One-Day Travel Spots Near Morachi Chincholi",
    "description": "Anand Krushi Paryatan Kendra is one of the top one-day travel spots near Morachi Chincholi, offering a perfect rural escape. Enjoy farming experiences, nature trails, and local cuisine—all in a short, easy trip from Pune."
  },
  {
    "name": "Best Short Getaways Near Pune",
    "description": "Looking for a quick break? This eco-farm combines scenic beauty, fun farm activities, and peaceful surroundings—making it one of the best short getaways near Pune for nature lovers and families alike."
  },
  {
    "name": "Family-Friendly Short Trips from Morachi Chincholi",
    "description": "Spend quality time with your family at Anand Krushi Paryatan Kendra. Children love feeding animals and playing traditional village games, while adults enjoy nature, local food, and relaxing outdoor spaces."
  },
  {
    "name": "Short Distance Nature Destinations",
    "description": "Just a short drive from Pune or Morachi Chincholi, the farm offers fresh air, green views, and peaceful rural vibes—perfect for nature lovers seeking a quick escape without a long journey."
  },
  {
    "name": "Weekend Short Trips Near Morachi Chincholi",
    "description": "For a refreshing weekend, visit Anand Krushi Paryatan Kendra. Whether it’s farm tours, mango tasting, or simply relaxing in a hammock, this destination has something for everyone—young or old."
  },
  {
    "name": "Budget Day Trip Spots",
    "description": "Enjoy a full day of rural experiences—meals, nature walks, and games—at a pocket-friendly price. Anand Krushi Paryatan Kendra offers one of the best budget day trip options near Pune and Morachi Chincholi."
  },
  {
    "name": "Short Romantic Trips from Pune",
    "description": "Couples can enjoy quiet walks through the fields, sit by the farm pond, or share a rustic meal in a serene village setting. It’s the perfect romantic escape from the city—for just a day."
  },
  {
    "name": "Nearby Villages to Explore from Morachi Chincholi",
    "description": "Extend your farm visit with a tour of nearby villages where you can experience traditional life, interact with locals, and explore hidden temples or rustic markets for a deeper cultural connection."
  },
  {
    "name": "Peaceful Countryside Spots for a Day",
    "description": "Relax, breathe, and slow down. Anand Krushi Paryatan Kendra offers a quiet, stress-free space surrounded by greenery and simplicity—ideal for those looking to disconnect and recharge."
  },
  {
    "name": "Eco-Tourism Short Trip Options",
    "description": "Experience responsible travel through eco-friendly farming, composting demos, and nature education—all part of Anand Krushi Paryatan Kendra’s commitment to sustainable tourism."
  },
  {
    "name": "Historical Short Trips Near Morachi Chincholi",
    "description": "Combine your day with a visit to nearby historical temples or forts, followed by a relaxing meal and rest at the farm. It’s the perfect balance of history and hospitality in a single trip."
  },
  {
    "name": "Scenic Locations for Quick Visits",
    "description": "From sunrise over the fields to peacocks dancing at sunset, the farm is full of photogenic moments. Ideal for nature lovers and photographers wanting to capture scenic rural beauty."
  },
  {
    "name": "Short Adventure Outings",
    "description": "Add a dash of excitement to your day with low-impact adventure games like rope climbing, tire walking, and nature scavenger hunts—safe, fun, and suitable for all age groups."
  },
  {
    "name": "Quick Cultural Experiences Near Pune",
    "description": "Witness bullock cart rides, local folk music, and traditional village life, all in one visit. Anand Krushi Paryatan Kendra offers cultural immersion without needing to travel far."
  },
  {
    "name": "Local Flavor Destinations for a Short Trip",
    "description": "Taste authentic rural food made from farm-fresh ingredients. From Aamras to bhakri, every dish at Anand Krushi Paryatan Kendra gives you a true taste of Maharashtra’s countryside."
  }
],
"tableData": [
  ["One-Day Travel Spots Near Morachi Chincholi", "- Best Short Getaways Near Pune"],
  ["Family-Friendly Short Trips from Morachi Chincholi", "- Short Distance Nature Destinations"],
  ["Weekend Short Trips Near Morachi Chincholi", "- Budget Day Trip Spots"],
  ["Short Romantic Trips from Pune", "- Nearby Villages to Explore from Morachi Chincholi"],
  ["Peaceful Countryside Spots for a Day", "- Eco-Tourism Short Trip Options"],
  ["Historical Short Trips Near Morachi Chincholi", "- Scenic Locations for Quick Visits"],
  ["Short Adventure Outings", "- Quick Cultural Experiences Near Pune"],
  ["Local Flavor Destinations for a Short Trip", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Morachi Chincholi Peacock Sanctuary",
    "WhyChoosedescription": "A quick getaway to the renowned Peacock Village, where thousands of peacocks roam freely among sprawling tamarind trees. It offers a rare chance to witness vibrant peacock dances and calls up close in a serene rural setting, just a short drive from Pune."
  },
  {
    "WhyChooseheading": "Anand Krushi Paryatan Kendra",
    "WhyChoosedescription": "This agro-tourism center provides visitors with engaging activities like bullock cart rides, tractor tours, farm animal interactions, and traditional Marathi cuisine. It’s a perfect spot for families and nature lovers to experience authentic village life in a relaxed environment."
  },
  {
    "WhyChooseheading": "Nighoj Potholes",
    "WhyChoosedescription": "Located approximately 25 km from Morachi Chincholi, these unique geological formations carved by the Kukadi River present a fascinating natural wonder. Ideal for a short exploratory trip that combines nature, education, and photography."
  },
  {
    "WhyChooseheading": "Vadgaon Dam Picnic Spot",
    "WhyChoosedescription": "A tranquil destination for a peaceful picnic amidst lush greenery. Vadgaon Dam offers calm waters, open spaces, and scenic views perfect for unwinding with family or friends on a short trip."
  },
  {
    "WhyChooseheading": "Ranjangaon Mahaganpati Temple",
    "WhyChoosedescription": "A significant religious site about 40 km away, this Ashtavinayak temple attracts devotees and tourists alike. Its spiritual ambiance and beautiful architecture make it a worthy stop on any short trip itinerary."
  },
  {
    "WhyChooseheading": "Shirur Fort",
    "WhyChoosedescription": "Just 20 km from Morachi Chincholi, this historical fort offers panoramic views and a peek into Maratha heritage. It’s an excellent destination for history enthusiasts looking for a brief cultural excursion."
  }
]
















    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Is Morachi Chincholi suitable for a short trip from Pune?',
    answer: 'Yes! Located just 65 km from Pune, it’s perfect for a half-day or full-day trip to enjoy nature, peacocks, and rural tourism.',
  },
  {
    id: 'FAQ2',
    question: 'What can I do during a short trip to Morachi Chincholi?',
    answer: 'You can enjoy peacock sightings, bullock cart rides, traditional farm meals, butterfly gardens, and guided village tours.',
  },
  {
    id: 'FAQ3',
    question: 'How much time is needed to explore Morachi Chincholi?',
    answer: 'Around 4–6 hours is sufficient to cover major activities like farm visits, lunch, and nature walks, making it ideal for a short trip.',
  },
  {
    id: 'FAQ4',
    question: 'Are there any attractions near Morachi Chincholi for a combined trip?',
    answer: 'Yes. You can pair your visit with Ranjangaon Ganpati Temple, Alandi, or even Shikrapur for a culturally enriched day.',
  },
  {
    id: 'FAQ5',
    question: 'What is the main highlight of Morachi Chincholi?',
    answer: 'The village is famous for its natural peacock population — one of the few places in India where they roam freely in the wild.',
  },
  {
    id: 'FAQ6',
    question: 'Is Morachi Chincholi good for couples or solo travelers?',
    answer: 'Yes. It’s peaceful, scenic, and offers a relaxing break from the city with great photo spots, especially during monsoon.',
  },
  {
    id: 'FAQ7',
    question: 'What are the food options for a short trip?',
    answer: 'Local agro-tourism centers like Anand Krushi serve traditional Maharashtrian meals prepared with fresh, organic farm produce.',
  },
  {
    id: 'FAQ8',
    question: 'Is it suitable for a quick trip with kids or elderly?',
    answer: 'Absolutely. The terrain is flat and accessible, with shaded areas, rest facilities, and fun activities for all age groups.',
  },
  {
    id: 'FAQ9',
    question: 'Do I need to carry anything special for a short trip here?',
    answer: 'Carry a hat, sunscreen, camera, water, and wear comfortable shoes. Monsoon visitors should bring an umbrella or raincoat.',
  },
  {
    id: 'FAQ10',
    question: 'What is the best season to visit Morachi Chincholi?',
    answer: 'The best time is from June to November when peacocks are most active and the landscape is lush and green.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Harshad Patil, Pune',
    feedback: "Our short trip to Morachi Chincholi was peaceful and refreshing. Just a couple of hours away from Pune, but felt like a complete change of scene.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shreya Kulkarni, PCMC',
    feedback: "It’s the perfect short getaway — fresh air, peacocks, tasty food, and simple village charm. Will visit again during monsoon!",
    rating: 5,
  },
];



















    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Short Trip Destinations Morachi Chincholi Pune",
  "image": "https://morachichincholi.in/assets/images/short-trip-destinations-morachi-chincholi.jpg",
  "description": "Explore the best short trip destinations near Morachi Chincholi, Pune. Perfect for family-friendly getaways, nature lovers, romantic quick trips, eco-tourism, historical visits, and budget-friendly weekend escapes.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "2050"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "610",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/short-trip-destinations"
  }
};



    return (
        <div>
<Helmet>
  <title>Short Trip Destinations Morachi Chincholi Pune | Family, Nature & Weekend Getaways</title>
  <meta 
    name="description" 
    content="Discover family-friendly and budget short trip destinations near Morachi Chincholi Pune. Enjoy nature, historical sites, eco-tourism, romantic escapes, and local cultural experiences for quick visits." 
  />
  <meta 
    name="keywords" 
    content="One-day travel spots near Morachi Chincholi, Best short getaways near Pune, Family-friendly short trips from Morachi Chincholi, Short distance nature destinations, Weekend short trips near Morachi Chincholi, Budget day trip spots, Short romantic trips from Pune, Nearby villages to explore from Morachi Chincholi, Peaceful countryside spots for a day, Eco-tourism short trip options, Historical short trips near Morachi Chincholi, Scenic locations for quick visits, Short adventure outings, Quick cultural experiences near Pune, Local flavor destinations for a short trip" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/19.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Shorttripdestinationmorachi;